import globals from './globals';
import helpers from './helpers';

function hasHoverSupport() {
	let hoverSupport;

	if (helpers.isIE() && helpers.getScrollbarWidth()) {
		hoverSupport = true;
	} else if (helpers.isMobile()) {
		hoverSupport = false;
	} else if (window.matchMedia('(any-hover: hover)').matches || window.matchMedia('(hover: hover)').matches) {
		hoverSupport = true;
	} else if (window.matchMedia('(hover: none)').matches) {
		hoverSupport = false;
	} else {
		hoverSupport = typeof globals.$html.ontouchstart === 'undefined';
	}

	return hoverSupport;
}

function setState() {
	if (!hasHoverSupport()) {
		globals.$app.removeClass('has-hover').addClass('no-hover');
	} else {
		globals.$app.removeClass('no-hover').addClass('has-hover');
	}
}

function resize() {
	helpers.resize('hover', setState);
}

setState();

globals.$window
	.data('width-hover', innerWidth)
	.on('resize', resize);
